module.exports = __webpack_public_path__ + "dingbeauty-build/img/logo-default.67cc6a72.svg";